import { render, staticRenderFns } from "./a.vue?vue&type=template&id=f13a0102&scoped=true"
import script from "./a.vue?vue&type=script&lang=js"
export * from "./a.vue?vue&type=script&lang=js"
import style0 from "./a.vue?vue&type=style&index=0&id=f13a0102&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f13a0102",
  null
  
)

export default component.exports